export const enableNewsletterEditor = true;

export const STORAGE_NAMESPACE = {
  EMAILS: "EMAILS",
  LAYOUTS: "LAYOUTS",
  COMPONENTS: "COMPONENTS",
};

export const MAX_UNDO_STEPS = 50;

/** @deprecated Use flex layout + useEditorViewportHeight; kept as fallback minimum. */
export const EDITOR_PANEL_HEIGHT = 640;

/** Shared min/max for property sliders in the editor UI. */
export const EDITOR_SLIDER_LIMITS = {
  percent: { min: 1, max: 100 },
  layoutWidthPercent: { min: 10, max: 100 },
  imageWidthPercent: { min: 5, max: 100 },
  imageFixedWidthPx: { min: 0, max: 800 },
  imageFixedHeightPx: { min: 0, max: 800 },
  columnWidthPercent: { min: 5, max: 95 },
  buttonWidthPercent: { min: 0, max: 100 },
  spacingPx: { min: 0, max: 120 },
  layoutMarginPx: { min: 0, max: 120 },
  cellGapPx: { min: 0, max: 80 },
  fontSizePx: { min: 8, max: 96 },
  buttonPaddingXPx: { min: 0, max: 80 },
  buttonPaddingYPx: { min: 0, max: 64 },
  borderWidthPx: { min: 0, max: 20 },
  borderRadiusPx: { min: 0, max: 100 },
};

export const IMAGE_MAX_SIZE_BYTES = 2 * 1024 * 1024;

export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];
 